import React, { useState, useEffect } from "react";
import { config } from "../../config/config";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

const EnvironmentFilter = (props) => {
  const [environments, setEnvironments] = useState([]);
  const [selectedEnvironment, setSelectedEnvironment] = useState("");

  const handleFilterChange = (e) => {
    console.log(e);
    setSelectedEnvironment(e.target.value);
    props.onChange(e);
  };
  useEffect(() => {
    fetch(config.API_URL + `/Environment`)
      .then((res) => res.json())
      .then((data) => {
        setEnvironments(data);
      });
  }, []);
  return (
    <FormControl size="medium" sx={{ margin: 1.3 }}>
      <InputLabel id={`environments-select-label`}>Environments</InputLabel>
      <Select
        sx={{ minWidth: 200 }}
        labelId={`environments-select-label`}
        name={props.name !== undefined ? props.name : "environment"}
        id={`environments-select`}
        value={selectedEnvironment}
        label="Environments"

        onChange={(e) => handleFilterChange(e)}
      >
        {environments.length > 0 &&
          environments.map((s, i) => (
            <MenuItem value={s.environment} key={i}>
              {s.environment}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
};
export default EnvironmentFilter;
